import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess11722Status: 'idle',
    startProcess11722Error: undefined as any,
    loadUserParamsProcess11722Status: 'idle',
    loadUserParamsProcess11722Error: undefined as any,
    stammIni_EnableSprachenStatus: 'idle',
    stammIni_EnableSprachenError: undefined as any,

    process11722List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    stammIni_EnableSprachen: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess11722 = createAsyncThunk('process11722Slice/startProcess11722', async ({ process11722 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess11722/`,
        prepareData(process11722),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess11722Status } = getState().process11722Slice
        return startProcess11722Status !== 'pending'
    }
})

export const loadUserParamsProcess11722 = createAsyncThunk('process11722Slice/loadUserParamsProcess11722', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess11722/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess11722Status } = getState().process11722Slice
        return loadUserParamsProcess11722Status !== 'pending'
    }
})

export const stammIni_EnableSprachen = createAsyncThunk('process11722Slice/stammIni_EnableSprachen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_EnableSprachen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { stammIni_EnableSprachenStatus } = getState().process11722Slice
        return stammIni_EnableSprachenStatus !== 'pending'
    }
})

const Process11722Slice = createSlice({
    name: 'process11722Slice',
    initialState,
    reducers: {
        resetstartProcess11722: (state) => {
            state.job = undefined
            state.startProcess11722Error = undefined
        },
        resetstartProcess11722Error: (state) => {
            state.startProcess11722Error = undefined
        },
        resetloadUserParamsProcess11722: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess11722Error = undefined
        },
        resetloadUserParamsProcess11722Error: (state) => {
            state.loadUserParamsProcess11722Error = undefined
        },
        resetstammIni_EnableSprachen: (state) => {
            state.stammIni_EnableSprachen = undefined
            state.stammIni_EnableSprachenError = undefined
        },
        resetstammIni_EnableSprachenError: (state) => {
            state.stammIni_EnableSprachenError = undefined
        },
        removeFromProcess11722ListById: (state, action) => {
            state.process11722List = state.process11722List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess11722ListByIds: (state, action) => {
            state.process11722List = state.process11722List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process11722List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess11722Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process11722List = []
            state.startProcess11722Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess11722.pending, (state) => {
            state.startProcess11722Status = 'pending'
            state.startProcess11722Error = undefined
        })
        builder.addCase(startProcess11722.fulfilled, (state, action) => {
            state.startProcess11722Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.job = newItem
            }
        })
        builder.addCase(startProcess11722.rejected, (state, action) => {
            state.startProcess11722Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess11722Error = action.error.message
            } else {
                state.startProcess11722Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess11722.pending, (state) => {
            state.loadUserParamsProcess11722Status = 'pending'
            state.loadUserParamsProcess11722Error = undefined
        })
        builder.addCase(loadUserParamsProcess11722.fulfilled, (state, action) => {
            state.loadUserParamsProcess11722Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultValues = newItem
            }
        })
        builder.addCase(loadUserParamsProcess11722.rejected, (state, action) => {
            state.loadUserParamsProcess11722Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess11722Error = action.error.message
            } else {
                state.loadUserParamsProcess11722Error = action.payload
            }
        })

        builder.addCase(stammIni_EnableSprachen.pending, (state) => {
            state.stammIni_EnableSprachenStatus = 'pending'
            state.stammIni_EnableSprachenError = undefined
        })
        builder.addCase(stammIni_EnableSprachen.fulfilled, (state, action) => {
            state.stammIni_EnableSprachenStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.stammIni_EnableSprachen = newItem
            }
        })
        builder.addCase(stammIni_EnableSprachen.rejected, (state, action) => {
            state.stammIni_EnableSprachenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.stammIni_EnableSprachenError = action.error.message
            } else {
                state.stammIni_EnableSprachenError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess11722,
    resetstartProcess11722Error,
    resetloadUserParamsProcess11722,
    resetloadUserParamsProcess11722Error,
    resetstammIni_EnableSprachen,
    resetstammIni_EnableSprachenError,
    removeFromProcess11722ListById,
    removeFromProcess11722ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process11722Slice.actions
export default Process11722Slice.reducer
